export const initialState = {
  prompts: null,        // { write, build, entertain, question } from config/dailyPrompts
  entries: [],          // Entry[] for current user, newest first
  todayEntry: null,     // Entry | null — today's entry if it exists
  loading: true,
  activeTab: 'today',   // 'today' | 'journal' | 'feed' | 'friends'
  friends: [],          // { userId, displayName, photoURL, addedAt }[]
  friendEntries: {},    // { [friendUserId]: Entry[] }
  activeDetail: null,   // { ownerUserId, entryId, categoryKey, responseText, entryDate, ownerName, isOwn }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'SET_PROMPTS':
      return { ...state, prompts: action.prompts };

    case 'SET_ENTRIES':
      return {
        ...state,
        entries: action.entries,
        todayEntry: action.entries.find(e => e.date === todayDateStr()) || null,
        loading: false,
      };

    case 'SET_TODAY_ENTRY':
      return {
        ...state,
        todayEntry: action.entry,
        entries: upsertEntry(state.entries, action.entry),
      };

    case 'SET_ACTIVE_TAB':
      return { ...state, activeTab: action.tab };

    case 'SET_FRIENDS':
      return { ...state, friends: action.friends };

    case 'SET_FRIEND_ENTRIES':
      return {
        ...state,
        friendEntries: { ...state.friendEntries, [action.friendId]: action.entries },
      };

    case 'REMOVE_FRIEND_ENTRIES': {
      const { [action.friendId]: _removed, ...rest } = state.friendEntries;
      return { ...state, friendEntries: rest };
    }

    case 'OPEN_DETAIL':
      return { ...state, activeDetail: action.detail };

    case 'CLOSE_DETAIL':
      return { ...state, activeDetail: null };

    default:
      return state;
  }
}

function todayDateStr() {
  return new Date().toISOString().slice(0, 10);
}

function upsertEntry(entries, entry) {
  const exists = entries.find(e => e.id === entry.id);
  if (exists) return entries.map(e => e.id === entry.id ? entry : e);
  return [entry, ...entries].sort((a, b) => b.date.localeCompare(a.date));
}
